import { DataValidator, IsBoolean, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface MyAudioToggleFavoriteProps {
  audioId: string;
}

interface MyAudioToggleFavoriteParams {
  customize_audio_template_id: string;
}

interface MyAudioToggleFavoriteResponse {
  is_favorite: boolean;
  message: string;
}

export class MyAudioToggleFavoriteData {
  @Required("isFavorite ID cannot be empty")
  @IsBoolean("isFavorite must be a boolean")
  isFavorite: boolean;
}

const transformAndValidateData = (
  response: MyAudioToggleFavoriteResponse
): MyAudioToggleFavoriteData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, MyAudioToggleFavoriteData);
  } catch (error) {
    console.error("MyAudioToggleFavorite data validation failed:", error.message);
    throw error;
  }
};

const URL = "/audio-template/toggle-favorite";

// 切换音频收藏状态
export const myAudioToggleFavorite = async (audioId: MyAudioToggleFavoriteProps["audioId"]) => {
  const params: MyAudioToggleFavoriteParams = {
    customize_audio_template_id: audioId,
  };
  const res = await api.post<MyAudioToggleFavoriteResponse>(URL, params);
  return transformAndValidateData(res.data);
};
